module.exports = __webpack_public_path__ + "img/lg_ring_g_skip_1_null@3x.47c76916.png";